import { GENDERS, TYPES, SIZE_CODES, MASTER_PRODUCTS } from 'constants/merchandising';

// Sock products have different priorities depending on the master product
const PRIORITIES = {
  SOCKS_1: 1,
  SOCKS_2: 2,
  SOCKS_3: 3,
  FACE_MASKS: 4,
  ZEFFER_STRAPS: 5,
  RUNNER_LACE_KIT: 6,
};

const RECOMMENDATION_TYPES = {
  SHOE_ACCESSORY: 'SHOE_ACCESSORY',
  MISCELLANEOUS: 'MISCELLANEOUS',
};

const SIZE_SELECTIONS = {
  FIRST_SIZE: 'FIRST_SIZE',
  MATCH_SIZE: 'MATCH_SIZE',
};

const COLOR_SELECTIONS = {
  CHOOSE_COLOR: 'CHOOSE_COLOR',
};

const RUNNER_LACE_KIT_RECOMMENDATION = {
  cta: 'cart.upsells.runnerLaceKit',
  masterProduct: MASTER_PRODUCTS.RUNNER_LACE_KIT,
  priority: PRIORITIES.RUNNER_LACE_KIT,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.FIRST_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const MENS_ZEFFER_STRAPS_RECOMMENDATION = {
  cta: 'cart.upsells.mensZefferStraps',
  masterProduct: MASTER_PRODUCTS.MENS_ZEFFER_STRAPS,
  priority: PRIORITIES.ZEFFER_STRAPS,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const WOMENS_ZEFFER_STRAPS_RECOMMENDATION = {
  cta: 'cart.upsells.womensZefferStraps',
  masterProduct: MASTER_PRODUCTS.WOMENS_ZEFFER_STRAPS,
  priority: PRIORITIES.ZEFFER_STRAPS,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const TRINO_TUBERS_RECOMMENDATION = {
  cta: 'cart.upsells.trinoTubers',
  masterProduct: MASTER_PRODUCTS.TRINO_TUBERS,
  priority: PRIORITIES.SOCKS_1,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const TRINO_HIDERS_RECOMMENDATION = {
  cta: 'cart.upsells.trinoHiders',
  masterProduct: MASTER_PRODUCTS.TRINO_HIDERS,
  priority: PRIORITIES.SOCKS_2,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const TRINO_QUARTERS_RECOMMENDATION = {
  cta: 'cart.upsells.trinoQuarters',
  masterProduct: MASTER_PRODUCTS.TRINO_QUARTERS,
  priority: PRIORITIES.SOCKS_3,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const TRINO_SPRINTERS_RECOMMENDATION = {
  cta: 'cart.upsells.trinoSprinters',
  masterProduct: MASTER_PRODUCTS.TRINO_SPRINTERS,
  priority: PRIORITIES.SOCKS_1,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.MATCH_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const FACE_MASKS_RECOMMENDATION = {
  cta: null,
  masterProduct: MASTER_PRODUCTS.FACE_MASK,
  priority: PRIORITIES.FACE_MASKS,
  type: RECOMMENDATION_TYPES.SHOE_ACCESSORY,
  sizeSelection: SIZE_SELECTIONS.FIRST_SIZE,
  colorSelection: COLOR_SELECTIONS.CHOOSE_COLOR,
};

const RECOMMENDATIONS = {
  [MASTER_PRODUCTS.MENS_TRINO_PUFFER]: [FACE_MASKS_RECOMMENDATION],
  [MASTER_PRODUCTS.WOMENS_TRINO_PUFFER]: [FACE_MASKS_RECOMMENDATION],

  [MASTER_PRODUCTS.MENS_WOOL_CARDI]: [FACE_MASKS_RECOMMENDATION],
  [MASTER_PRODUCTS.WOMENS_WOOL_CARDI]: [FACE_MASKS_RECOMMENDATION],

  [MASTER_PRODUCTS.MENS_WOOL_JUMPER]: [FACE_MASKS_RECOMMENDATION],
  [MASTER_PRODUCTS.WOMENS_WOOL_JUMPER]: [FACE_MASKS_RECOMMENDATION],

  [MASTER_PRODUCTS.MENS_TRINO_XO_TEE]: [FACE_MASKS_RECOMMENDATION],
  [MASTER_PRODUCTS.WOMENS_TRINO_XO_TEE]: [FACE_MASKS_RECOMMENDATION],

  [MASTER_PRODUCTS.MENS_WOOL_RUNNERS]: [
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],
  [MASTER_PRODUCTS.WOMENS_WOOL_RUNNERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],

  [MASTER_PRODUCTS.MENS_TREE_RUNNERS]: [
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],
  [MASTER_PRODUCTS.WOMENS_TREE_RUNNERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],

  [MASTER_PRODUCTS.MENS_WOOL_RUNNER_MIZZLES]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],
  [MASTER_PRODUCTS.WOMENS_WOOL_RUNNER_MIZZLES]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],

  [MASTER_PRODUCTS.MENS_SUGAR_ZEFFERS]: [MENS_ZEFFER_STRAPS_RECOMMENDATION],
  [MASTER_PRODUCTS.WOMENS_SUGAR_ZEFFERS]: [WOMENS_ZEFFER_STRAPS_RECOMMENDATION],

  [MASTER_PRODUCTS.MENS_TREE_TOPPERS]: [
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
  ],
  [MASTER_PRODUCTS.WOMENS_TREE_TOPPERS]: [
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
  ],

  [MASTER_PRODUCTS.MENS_WOOL_RUNNER_UP_MIZZLES]: [
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],
  [MASTER_PRODUCTS.WOMENS_WOOL_RUNNER_UP_MIZZLES]: [
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    RUNNER_LACE_KIT_RECOMMENDATION,
  ],

  [MASTER_PRODUCTS.MENS_TREE_SKIPPERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],
  [MASTER_PRODUCTS.WOMENS_TREE_SKIPPERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],

  [MASTER_PRODUCTS.MENS_TREE_LOUNGERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],
  [MASTER_PRODUCTS.WOMENS_TREE_LOUNGERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],

  [MASTER_PRODUCTS.MENS_WOOL_LOUNGERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],
  [MASTER_PRODUCTS.WOMENS_WOOL_LOUNGERS]: [
    { ...TRINO_HIDERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_3 },
  ],

  [MASTER_PRODUCTS.WOMENS_TREE_BREEZERS]: [
    { ...TRINO_TUBERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
    { ...TRINO_QUARTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_2 },
  ],

  [MASTER_PRODUCTS.MENS_TREE_DASHERS]: [
    { ...TRINO_SPRINTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
  ],
  [MASTER_PRODUCTS.WOMENS_TREE_DASHERS]: [
    { ...TRINO_SPRINTERS_RECOMMENDATION, priority: PRIORITIES.SOCKS_1 },
  ],
};

const SOCKS = SIZE_CODES.SOCKS.UNISEX;
const MENS_SHOES = SIZE_CODES.SHOES.MENS;
const WOMENS_SHOES = SIZE_CODES.SHOES.WOMENS;

const SIZE_CODE_MAP = {
  [TYPES.SHOES]: {
    [TYPES.SOCKS]: {
      [GENDERS.WOMENS]: {
        [WOMENS_SHOES['5']]: SOCKS.SMALL,
        [WOMENS_SHOES['5.5']]: SOCKS.SMALL,
        [WOMENS_SHOES['6']]: SOCKS.SMALL,
        [WOMENS_SHOES['6.5']]: SOCKS.SMALL,
        [WOMENS_SHOES['7']]: SOCKS.SMALL,
        [WOMENS_SHOES['7.5']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['8']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['8.5']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['9']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['9.5']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['10']]: SOCKS.MEDIUM,
        [WOMENS_SHOES['10.5']]: SOCKS.LARGE,
        [WOMENS_SHOES['11']]: SOCKS.LARGE,
      },
      [GENDERS.MENS]: {
        [MENS_SHOES['7']]: SOCKS.MEDIUM,
        [MENS_SHOES['7.5']]: SOCKS.MEDIUM,
        [MENS_SHOES['8']]: SOCKS.MEDIUM,
        [MENS_SHOES['8.5']]: SOCKS.MEDIUM,
        [MENS_SHOES['9']]: SOCKS.LARGE,
        [MENS_SHOES['9.5']]: SOCKS.LARGE,
        [MENS_SHOES['10']]: SOCKS.LARGE,
        [MENS_SHOES['10.5']]: SOCKS.LARGE,
        [MENS_SHOES['11']]: SOCKS.LARGE,
        [MENS_SHOES['11.5']]: SOCKS.LARGE,
        [MENS_SHOES['12']]: SOCKS.LARGE,
        [MENS_SHOES['12.5']]: SOCKS.LARGE,
        [MENS_SHOES['13']]: SOCKS.EXTRA_LARGE,
        [MENS_SHOES['13.5']]: SOCKS.EXTRA_LARGE,
        [MENS_SHOES['14']]: SOCKS.EXTRA_LARGE,
      },
    },
  },
};

const RECOMMENDATION_CONFIGS = {
  RUNNER_LACE_KIT_RECOMMENDATION,
  MENS_ZEFFER_STRAPS_RECOMMENDATION,
  WOMENS_ZEFFER_STRAPS_RECOMMENDATION,
  TRINO_TUBERS_RECOMMENDATION,
  TRINO_HIDERS_RECOMMENDATION,
  TRINO_QUARTERS_RECOMMENDATION,
  TRINO_SPRINTERS_RECOMMENDATION,
  FACE_MASKS_RECOMMENDATION,
};

export {
  RECOMMENDATIONS,
  RECOMMENDATION_CONFIGS,
  COLOR_SELECTIONS,
  SIZE_SELECTIONS,
  RECOMMENDATION_TYPES,
  SIZE_CODE_MAP,
};
